import { IChangeSubCategoryPositionState } from './changeSubCategoryPositionContext';
import {
	ChangeSubCategoryPositionActionTypes,
	TChangeSubCategoryPositionActions,
} from './changeSubCategoryPositionActions';

export const changeSubCategoryPositionReducer = (
	state: IChangeSubCategoryPositionState,
	action: TChangeSubCategoryPositionActions,
): IChangeSubCategoryPositionState => {
	switch (action.type) {
		case ChangeSubCategoryPositionActionTypes.SET_ID_CUSTOMER:
			return {
				...state,
				IDSelectedCustomer: action.payload.IDSelectedCustomer,
				selectedRestaurant: null,
				IDSelectedCategory: null,
				positionsData: [],
			};
		case ChangeSubCategoryPositionActionTypes.SET_RESTAURANT:
			return {
				...state,
				selectedRestaurant: action.payload.selectedRestaurant,
				IDSelectedCategory: null,
				positionsData: [],
			};
		case ChangeSubCategoryPositionActionTypes.SET_ID_CATEGORY:
			return {
				...state,
				IDSelectedCategory: action.payload.IDSelectedCategory,
				positionsData: [],
			};
		case ChangeSubCategoryPositionActionTypes.RESET_SELECTED_CONTROLS:
			return {
				...state,
				IDSelectedCustomer: null,
				selectedRestaurant: null,
				IDSelectedCategory: null,
				positionsData: [],
			};
		case ChangeSubCategoryPositionActionTypes.SET_POSITIONS_DATA:
			return {
				...state,
				positionsData: action.payload.positionsData,
			};
		case ChangeSubCategoryPositionActionTypes.REORDER_ITEMS:
			return {
				...state,
				positionsData: action.payload.newOrder,
			};
		case ChangeSubCategoryPositionActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case ChangeSubCategoryPositionActionTypes.SET_VISIBLE_ADDITIONAL_RESTAURANTS_MODAL:
			return {
				...state,
				isVisibleAdditionalRestaurantsModal: action.payload.isVisible,
				isApplyToOne: action.payload.isApplyToOne,
				selectedAdditionalRestaurants: action.payload.selectedAdditionalRestaurants,
				selectSearchString: action.payload.selectSearchString,
			};
		case ChangeSubCategoryPositionActionTypes.TOGGLE_APPLY_TO_ONE:
			return {
				...state,
				isApplyToOne: !state.isApplyToOne,
				selectedAdditionalRestaurants: [],
			};
		case ChangeSubCategoryPositionActionTypes.SET_ADDITIONAL_RESTAURANTS:
			return {
				...state,
				selectedAdditionalRestaurants: action.payload.additionalRestaurants,
			};
		case ChangeSubCategoryPositionActionTypes.CHANGE_SELECT_SEARCH_STRING:
			return {
				...state,
				selectSearchString: action.payload.searchString,
			};
		default:
			return state;
	}
};
